export const submissionPaths = [
  `/:organisation/open-reporting`,
  `/:organisation/open-reporting/relationship`,
  `/:organisation/open-reporting/country`,
  `/:organisation/open-reporting/site`,
  `/:organisation/open-reporting/submission-type`,
  `/:organisation/open-reporting/perpetrators`,
  `/:organisation/open-reporting/location`,
  `/:organisation/open-reporting/date`,
  `/:organisation/open-reporting/time`,
  `/:organisation/open-reporting/description`,
  `/:organisation/open-reporting/question`,
  `/:organisation/open-reporting/emotion`,
  `/:organisation/open-reporting/witnesses`,
  `/:organisation/open-reporting/file-upload`,
  `/:organisation/open-reporting/details`,
  `/:organisation/open-reporting/password`,
  `/:organisation/open-reporting/success`,
];
